import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postFeatureFlag = (token, Active, FeatureName, FeatureDescription, PricePerMonth) => {
    return fetch(`${apiUrl}feature_flags`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            Active,
            FeatureName,
            FeatureDescription,
            PricePerMonth
        })
    });
}

export default postFeatureFlag